<template>
  <GenericProgressLinear :icon="'mdi-fencing'" :title="'Bosses'" :stats="stats"></GenericProgressLinear>
</template>

<script>
import { mapGetters } from "vuex"
import GenericProgressLinear from "./GenericProgressLinear"

export default {
  name: "BossesProgressLinear",
  components: { GenericProgressLinear },
  computed: {
    ...mapGetters("entities/bosses",["stats"])
  },
};
</script>
